export default "{{savingsPercentage}}%";